<template>
  <div>
    <v-snackbar v-model="hideActionsTable" :timeout="0" :multi-line="true">
      Sort data
      <v-card-actions v-if="sort_data == true">
        <v-btn
          @click="cancelSortData()"
          :loading="cancel_sort"
          :disabled="cancel_sort || sorting_data || fetching_data"
          color="red"
          dark
          >Cancel</v-btn
        >

        <v-btn
          @click="saveSort()"
          :loading="sorting_data"
          :disabled="sorting_data || cancel_sort || fetching_data"
          color="green"
          dark
          >Apply sort</v-btn
        >
        <label v-if="sort_msg == 3">Can't sort</label>
      </v-card-actions>
    </v-snackbar>
    <v-btn
      absolute
      dark
      fab
      top
      right
      v-if="!sort_data"
      :disabled="sorting_data || cancel_sort"
      color="primary"
      style="top: 10px"
      @click="bannerDialog = true"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <bannerForm
      :isLoadingStore="isLoadingStore"
      :form="form"
      @setForm="setForm()"
      @failed="openSnackBar = true"
      :dialog="bannerDialog"
      @setDialog="bannerDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      @cancel="cancelBannerForm()"
      @save="
        initialize();
        bannerDialog = false;
      "
    />
    <h1 class="text-xs-center">Banner on Merchant</h1>
    <!-- <v-layout row>
      <v-flex xs6 class="text-xs-left">
        <v-toolbar dense flat>
          <v-btn @click="startSort()" v-if="sort_data == false" round dark
            >Start sort</v-btn
          >
        </v-toolbar>
      </v-flex>

      <v-flex xs12>
        <v-spacer></v-spacer>
        <v-toolbar dense flat>
          <v-text-field
            :disabled="sort_data"
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout> -->
    <v-data-table
      :loading="fetching_data"
      :headers="headers"
      :items="filteredBannerList"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td class="px-1 handle" style="width: 0.1%" v-if="sort_data == true">
          <v-btn style="cursor: move" icon :disabled="sorting_data">
            <v-icon>drag_indicator</v-icon>
          </v-btn>
        </td>

        <td style="padding: 6px 0 0 0">
          <img
            :src="props.item.banner_merchant_image"
            width="245px"
            height="100px"
          />
        </td>
        <td
          class="text-xs-center"
          v-if="
            props.item.banner_merchant_province.length > 0 &&
            props.item.banner_merchant_province[0] === 0
          "
        >
          All Province
        </td>
        <td class="text-xs-center" v-else>
          <div
            v-for="(province, index) in props.item.banner_merchant_province"
            :key="index"
          >
            {{ findProvinceById(province) }}
          </div>
        </td>
        <!-- <td
          class="text-xs-center"
          v-if="
            props.item.banner_merchant_store.length > 0 &&
            props.item.banner_merchant_store[0] === 0
          "
        >
          All Store
        </td> -->

        <td class="text-xs-center">
          {{
            moment(props.item.banner_merchant_date_start).format("YYYY-mm-DD")
          }}
        </td>
        <td class="text-xs-center">
          {{ moment(props.item.banner_merchant_date_end).format("YYYY-mm-DD") }}
        </td>
        <td class="text-xs-center" style="position: relative">
          <v-switch
            v-if="!sort_data"
            @change="changeStatusBanner(props.item)"
            v-model="props.item.banner_merchant_active"
            color="primary"
            class="status_toggle"
          ></v-switch>
        </td>
        <td class="text-xs-center" style="position: relative">
          <v-tooltip top>
            <v-btn
              v-if="!sort_data"
              :disabled="sorting_data || cancel_sort"
              icon
              @click="editBanner(props.item)"
              slot="activator"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              v-if="!sort_data"
              icon
              slot="activator"
              @click="deleteBanner(props.item)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="fetching_data == false" class="text-xs-center">
          No notification
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
    <div class="text-xs-center mt-4">
      <v-pagination
        @input="initialize()"
        v-model="pageTable"
        :length="Math.ceil(totalItems / rowsPerPage)"
      ></v-pagination>
    </div>
    <v-snackbar
      v-model="openSnackBar"
      :bottom="null"
      :top="true"
      :right="null"
      :left="null"
      :multi-line="false"
      :timeout="3000"
      :vertical="false"
    >
      <span> <v-icon color="error">close</v-icon>Something went wrong!</span>
    </v-snackbar>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import bannerForm from "./MerchantBanners/MerchantBannerForm.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
export default {
  components: {
    bannerForm,
  },
  data() {
    return {
      openSnackBar: false,
      hideActionsTable: false,
      totalItems: 0,
      rowsPerPage: 5,
      pageTable: 1,
      isLoadingStore: false,
      data_for_sort: {},
      sort_data: false,
      sort_msg: 0,
      cancel_sort: false,
      sorting_data: false,
      original_data: {},
      form: {
        banner_merchant_province: [],
        banner_merchant_image: "",
        banner_merchant_date_start: "",
        banner_merchant_date_end: "",
        banner_merchant_active: false,
        banner_merchant_type: 1,
        banner_merchant_store: [0],
      },

      fetching_data: false,
      search: "",
      bannerDialog: false,
      dialog: false,
      editedIndex: -1,
      headers: [
        {
          text: "Image",
          align: "center",
          sortable: false,
          value: "banner_img",
        },
        {
          text: "Province",
          align: "center",
          sortable: false,
          value: "banner_promotion_type_name_temp",
        },
        // {
        //   text: "Store",
        //   align: "center",
        //   sortable: false,
        //   value: "banner_promotion_name",
        // },
        {
          text: "Start date",
          align: "center",
          value: "banner_promotion_date_start",
          sortable: false,
        },
        {
          text: "End date",
          align: "center",
          value: "banner_promotion_date_end",
          sortable: false,
        },
        {
          text: "Change status",
          align: "center",
          value: "status",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          value: "action",
          sortable: false,
        },
      ],
      desserts: [
        {
          id: 1,
          banner_img: "",
          banner_name: "Frozen Yogurt",
          start_date: 24,
          end_date: 4.0,
          statur: "",
          action: "",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      merchantBannersList: (state) => state.advertising.merchantBannersList,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    ...mapGetters({
      autocompleteStore: "fetchStoreBack/autocompleteStore",
    }),
    filteredBannerList() {
      return this.merchantBannersList;
    },
  },
  methods: {
    ...mapActions({
      fetchBannerList: "advertising/FETCH_BANNERS_MERCHANT",
      deleteBannerItem: "advertising/DELETE_BANNERS_MERCHANT",
    }),
    moment,
    findProvinceById(Id) {
      try {
        let province = this.provinceData.find((val) => val.province_id == Id);
        return province.province_name_en;
      } catch (err) {
        return "Unknown";
      }
    },
    cancelBannerForm() {
      Object.assign(this.form, this.original_data);
    },
    setForm() {
      this.form = {
        banner_merchant_province: [],
        banner_merchant_store: [0],
        banner_merchant_image: "",
        banner_merchant_date_start: "",
        banner_merchant_date_end: "",
        banner_merchant_active: false,
        banner_merchant_type: 1,
      };
    },
    async setSortData(data) {
      let obj1 = JSON.parse(JSON.stringify(data));
      for (let key in obj1) {
        for (let x in obj1[key]) {
          if (x != "banner_promotion_id" && x != "banner_promotion_series") {
            delete obj1[key][x];
          }
        }
        obj1[key].banner_promotion_series = parseFloat(key) + 1;
      }
      return obj1;
    },
    async saveSort() {
      this.sorting_data = true;
      let obj1 = await this.setSortData(this.data_for_sort);
      this.sort_msg = await this.$store.dispatch(
        "fetchFoodPromotionBack/sortPromoBanner",
        obj1
      );
      if (this.sort_msg != 3) {
        await this.initialize();
        this.sort_data = false;
        this.hideActionsTable = false;
      }
      this.sorting_data = false;
    },
    startSort() {
      this.hideActionsTable = true;
      this.data_for_sort = JSON.parse(JSON.stringify(this.merchantBannersList));
      this.sort_data = true;
    },
    async cancelSortData() {
      this.cancel_sort = true;
      await this.initialize();
      this.cancel_sort = false;
      this.data_for_sort = {};
      this.sort_data = false;
      this.sort_msg = 0;
      this.hideActionsTable = false;
    },
    async deleteBanner(item) {
      let isConfirm = await confirm("ยืนยันการลบรายการ");
      if (isConfirm === true) {
        let result = await this.deleteBannerItem(item.banner_merchant_id);
        if (result == false) {
          this.openSnackBar = true;
        }
      }
    },
    async changeStatusBanner(item) {
      let clone_obj = JSON.parse(JSON.stringify(item));
      delete clone_obj.banner_merchant_image;
      let check = await this.$store.dispatch(
        "advertising/UPDATE_BANNERS_MERCHANT",
        clone_obj
      );

      if (check == false) {
        item.banner_merchant_active = !item.banner_merchant_active;
        this.openSnackBar = true;
      }
    },
    editBanner(item) {
      this.form = JSON.parse(JSON.stringify(item));
      this.form.banner_merchant_date_start = moment(
        item.banner_merchant_date_start
      ).format("YYYY-mm-DD");
      this.form.banner_merchant_date_end = moment(
        item.banner_merchant_date_end
      ).format("YYYY-mm-DD");
      this.bannerDialog = true;
      this.editedIndex = 1;
    },
    async fetchStoreList() {
      this.isLoadingStore = true;
      await this.$store.dispatch("fetchStoreBack/getStoreList");
      this.isLoadingStore = false;
    },
    async initialize() {
      this.fetching_data = true;
      let payload = {
        page_size: this.rowsPerPage,
        current_page: this.pageTable,
        store_id: "[0]",
        province_id: "[0]",
        banner_merchant_active: "[true, false]",
      };
      let response = await this.fetchBannerList(payload);
      this.totalItems = response.length || 0;
      this.fetching_data = false;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    let table = document.querySelector(".v-datatable tbody");
    const _self = this;
    Sortable.create(table, {
      handle: ".handle",
      onEnd({ oldIndex, newIndex }) {
        const rowSelected = _self.data_for_sort.splice(oldIndex, 1)[0];
        _self.data_for_sort.splice(newIndex, 0, rowSelected);
      },
    });
  },
  created() {
    this.initialize();
    this.fetchStoreList();
  },
};
</script>

<style scoped>
.status_toggle {
  position: absolute;
  top: 3rem;
  left: 40%;
}
</style>
